import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import './index.css';
import { BrowserRouter } from "react-router-dom";
//import express from 'express'
import App from './App';

const container = document.getElementById('root');

// Create a root - https://github.com/reactwg/react-18/discussions/5
const root = ReactDOMClient.createRoot(container);

// Initial render: Render an element to the root
root.render(
  <BrowserRouter><App /></BrowserRouter>
);